import { render } from "./coupons.vue?vue&type=template&id=65c27331&scoped=true"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"

import "./coupons.vue?vue&type=style&index=0&id=65c27331&lang=less&scoped=true"
import "./coupons.vue?vue&type=style&index=1&id=65c27331&lang=less"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c27331"]])

export default __exports__